/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Test_Print_Confirm_DescInputs */

const vi_print_admin_test_print_confirm_desc = /** @type {(inputs: Print_Admin_Test_Print_Confirm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy in ở điểm bán sẽ in lại phiếu gần nhất để kiểm tra đường in.`)
};

/**

* @param {Print_Admin_Test_Print_Confirm_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_test_print_confirm_desc = /** @type {((inputs?: Print_Admin_Test_Print_Confirm_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Test_Print_Confirm_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_test_print_confirm_desc(inputs)
});